// extracted by mini-css-extract-plugin
module.exports = {"slideStyles":"ResultsModal_slideStyles__3AeDv","innerSlideClass":"ResultsModal_innerSlideClass__2t8PR","customModal":"ResultsModal_customModal__2z5Ll"};